// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';
// COMPONENTS
import Select from 'react-select';
import Async from 'react-select/async';
import CreatableSelect from 'react-select/creatable'
// CUSTOM COMPONENTS
import CustomBlock from './CustomBlock';

const SelectBlock = (props) => {

    const errorMessageSuffix = "is required";
    const inputStates = {
        error: "error",
        warning: "warning",
        success: "success",
        disabled: "disabled"
    }

    return (
        <>
            <CustomBlock className={`input-block-container ${props.containerClassName ? props.containerClassName : ""}`}>
                {
                    props.inputLabel &&
                    <span className={`static-floating-label ${props.inputState}`}>
                        {props.inputLabel}{props.isRequired && <span className="danger--clr fw-600">*</span>}
                    </span>
                }

                {
                    props.label &&
                    <span className={`static-label ${props.inputState}`} style={{ display: 'inline-block', marginBottom: 10 }}>
                        {props.label}{props.isRequired && <span className="danger--clr fw-600">*</span>}
                    </span>
                }
                {
                    props.async ?
                        <Async
                            {...props}
                            placeholder={props.placeholder ? props.placeholder : (props.multiSelect ? "Select options" : "Select option")}
                            classNamePrefix={`${props.className ? props.className : ""} ${props.backgroundColor ? props.backgroundColor : "light--sbg"} ${props.inputState ? inputStates[props.inputState] : ""} ${props.bordered ? "bordered" : ""} ${!props.inputLabel || !props.label ? "padded" : ""}`}
                            isDisabled={props.disabled || props.inputState === "disabled" ? true : false}
                        />
                        :
                        props.creatableSelect ?
                            <CreatableSelect
                                {...props}
                                cacheOptions
                                placeholder={props.placeholder ? props.placeholder : (props.multiSelect ? "Select options" : "Select option")}
                                classNamePrefix={`${props.className ? props.className : ""} ${props.backgroundColor ? props.backgroundColor : "light--sbg"} ${props.inputState ? inputStates[props.inputState] : ""} ${props.bordered ? "bordered" : ""} ${!props.inputLabel || !props.label ? "padded" : ""}`}
                                isDisabled={props.disabled || props.inputState === "disabled" ? true : false}
                            />
                            :
                            <Select
                                {...props}
                                placeholder={props.placeholder ? props.placeholder : (props.multiSelect ? "Select options" : "Select option")}
                                classNamePrefix={`${props.className ? props.className : ""} ${props.backgroundColor ? props.backgroundColor : "light--sbg"} ${props.inputState ? inputStates[props.inputState] : ""} ${props.bordered ? "bordered" : ""} ${!props.inputLabel || !props.label ? "padded" : ""}`}
                                isDisabled={props.disabled || props.inputState === "disabled" ? true : false}
                            />
                }
                {
                    props.inputState === 'error' &&
                    <span className={`input-state-text error-message ${!props.inputLabel || props.label ? "unpadded" : ""}`}>
                        {props.errorMessage ? props.errorMessage : props.inputLabel || props.label ? (props.inputLabel || props.label + " " + errorMessageSuffix) : "Error message undefined"}
                    </span>
                }
                {
                    props.inputState === 'warning' &&
                    <span className={`input-state-text warning-message ${!props.inputLabel || props.label ? "unpadded" : ""}`}>
                        {props.warningMessage}
                    </span>
                }
                {
                    props.inputState === 'success' &&
                    <span className={`input-state-text success-message ${!props.inputLabel || props.label ? "unpadded" : ""}`}>
                        {props.successMessage}
                    </span>
                }
            </CustomBlock>
        </>
    )
}

SelectBlock.propTypes = {
    // CONTAINER PROPS
    containerClassName: PropTypes.string,

    // LABEL PROPS
    label: PropTypes.string,
    inputLabel: PropTypes.string,

    // STATE PROPS
    inputState: PropTypes.string,
    errorMessage: PropTypes.string,
    successMessage: PropTypes.string,
    warningMessage: PropTypes.string,

    // INPUT PROPS
    type: PropTypes.string,
    className: PropTypes.string,
    backgroundColor: PropTypes.string,
    placeholder: PropTypes.string,

    // BOOLEAN PROPS
    async: PropTypes.bool,
    creatableSelect: PropTypes.bool,
    isRequired: PropTypes.bool,
    disabled: PropTypes.bool,
    bordered: PropTypes.bool,
}

export default SelectBlock;